const generateSampleData = (prefix: string, size = 50) => {
  return Array.from({ length: size }, (_, i) => ({
    value: () => alert('Select clicked'),
    label: `${prefix} Option ${i + 1} with a very long text that should be truncated for UI`,
    fullLabel: `${prefix} Option ${i + 1} with a very long text that should be truncated for UI`,
    id: i,
    searchableLabel: `ssssOption ${i + 1}`,
    testId: `cs-option-${i + 1}`,
    redirectURL: `/#!/full-page/${i}`,
    icon: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTU2IDQ4QzE1NiA0MS4zNzI2IDE1MC42MjcgMzYgMTQ0IDM2QzEzNy4zNzMgMzYgMTMyIDQxLjM3MjYgMTMyIDQ4Vjg0SDk2QzcxLjY5OTUgODQgNTIgMTAzLjY5OSA1MiAxMjhWNDE2QzUyIDQ0MC4zMDEgNzEuNjk5NSA0NjAgOTYgNDYwSDQxNkM0NDAuMzAxIDQ2MCA0NjAgNDQwLjMwMSA0NjAgNDE2VjEyOEM0NjAgMTAzLjY5OSA0NDAuMzAxIDg0IDQxNiA4NEgzODBWNDhDMzgwIDQxLjM3MjYgMzc0LjYyNyAzNiAzNjggMzZDMzYxLjM3MyAzNiAzNTYgNDEuMzcyNiAzNTYgNDhWODRIMTU2VjQ4Wk00MzYgMTgwVjEyOEM0MzYgMTE2Ljk1NCA0MjcuMDQ2IDEwOCA0MTYgMTA4SDk2Qzg0Ljk1NDMgMTA4IDc2IDExNi45NTQgNzYgMTI4VjE4MEg0MzZaTTc2IDIwNEg0MzZWNDE2QzQzNiA0MjcuMDQ2IDQyNy4wNDYgNDM2IDQxNiA0MzZIOTZDODQuOTU0MyA0MzYgNzYgNDI3LjA0NiA3NiA0MTZWMjA0WiIgZmlsbD0iIzQ3NTE2MSIvPgo8cGF0aCBkPSJNMTc2IDI2NEMxNzYgMjc3LjI1NSAxNjUuMjU1IDI4OCAxNTIgMjg4QzEzOC43NDUgMjg4IDEyOCAyNzcuMjU1IDEyOCAyNjRDMTI4IDI1MC43NDUgMTM4Ljc0NSAyNDAgMTUyIDI0MEMxNjUuMjU1IDI0MCAxNzYgMjUwLjc0NSAxNzYgMjY0WiIgZmlsbD0iIzQ3NTE2MSIvPgo8cGF0aCBkPSJNMjcyIDI2NEMyNzIgMjc3LjI1NSAyNjEuMjU1IDI4OCAyNDggMjg4QzIzNC43NDUgMjg4IDIyNCAyNzcuMjU1IDIyNCAyNjRDMjI0IDI1MC43NDUgMjM0Ljc0NSAyNDAgMjQ4IDI0MEMyNjEuMjU1IDI0MCAyNzIgMjUwLjc0NSAyNzIgMjY0WiIgZmlsbD0iIzQ3NTE2MSIvPgo8cGF0aCBkPSJNMzY4IDI2NEMzNjggMjc3LjI1NSAzNTcuMjU1IDI4OCAzNDQgMjg4QzMzMC43NDUgMjg4IDMyMCAyNzcuMjU1IDMyMCAyNjRDMzIwIDI1MC43NDUgMzMwLjc0NSAyNDAgMzQ0IDI0MEMzNTcuMjU1IDI0MCAzNjggMjUwLjc0NSAzNjggMjY0WiIgZmlsbD0iIzQ3NTE2MSIvPgo8cGF0aCBkPSJNMTc2IDM2MEMxNzYgMzczLjI1NSAxNjUuMjU1IDM4NCAxNTIgMzg0QzEzOC43NDUgMzg0IDEyOCAzNzMuMjU1IDEyOCAzNjBDMTI4IDM0Ni43NDUgMTM4Ljc0NSAzMzYgMTUyIDMzNkMxNjUuMjU1IDMzNiAxNzYgMzQ2Ljc0NSAxNzYgMzYwWiIgZmlsbD0iIzQ3NTE2MSIvPgo8cGF0aCBkPSJNMjcyIDM2MEMyNzIgMzczLjI1NSAyNjEuMjU1IDM4NCAyNDggMzg0QzIzNC43NDUgMzg0IDIyNCAzNzMuMjU1IDIyNCAzNjBDMjI0IDM0Ni43NDUgMjM0Ljc0NSAzMzYgMjQ4IDMzNkMyNjEuMjU1IDMzNiAyNzIgMzQ2Ljc0NSAyNzIgMzYwWiIgZmlsbD0iIzQ3NTE2MSIvPgo8L3N2Zz4K',
  }))
}

const filterData = ({ search, skip, limit }: { search?: string; skip: number; limit: number }, prefix: string) => {
  let filteredData = generateSampleData(prefix)

  if (search) {
    filteredData = filteredData.filter((i) => i.label.toLowerCase().includes(search.toLowerCase()))
  }

  return {
    data: filteredData.slice(skip, skip + limit),
    count: filteredData.length
  }
}

const serveData = (prefix: string) => {
  return ({ search, skip, limit }: { search?: string; skip: number; limit: number }) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(filterData({ search, skip, limit }, prefix))
      }, 1000)
    })
  }
}

export const API_MAP = {
  apps: serveData(''),
  'assets-my-views': serveData('2'),
  'entries-my-views': serveData('3')
}

export const isMac = () => {
  if (typeof navigator === 'undefined') return false;

  const platform = (navigator as any).userAgentData?.platform || navigator.userAgent;
  return /Mac|iPod|iPhone|iPad/i.test(platform);
};
